<!--
 * @Description: 侧导航容器
 * @Author: youme
 * @LastEditors: youme
 * @Date: 2020-06-18 08:15:52
 * @LastEditTime: 2020-06-30 13:50:23
-->
<template>
  <nav class="sidebar hidden-md-and-down">
    <div class="sticky"><slot /></div>
  </nav>
</template>

<script>
export default {
  name: 'FlankNav'
}
</script>

<style lang="scss" scoped>
.sidebar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 240px;
  background: hsla(0,0%,98%,.9);
  margin-left: -600px;
  min-height: 700px;
  z-index: 9;
  .sticky {
    position: sticky;
    top: 0;
    padding-top: 40px;
  }
}
</style>
